// extracted by mini-css-extract-plugin
export var completionBody = "_eo-2";
export var completionCard = "_eo-0";
export var completionFooter = "_eo-3";
export var completionTitle = "_eo-1";